import React from 'react';
import { graphql } from 'gatsby';
import SEO from 'components/SEO';
import { Flex, Box, Container } from 'components/Grid';
import { Ul, Li } from 'components/List';
import H2 from 'components/H2';
import ProjectGridItem from 'components/ProjectGridItem';
import theme from 'utils/styles/theme';
import gridSettings from 'utils/styles/customGridSettings';
import Animate from 'components/Animate';
import HomeHero from 'components/HomeHero';
import css from '@styled-system/css';

const IndexPage = ({ data }) => {
	const { introText, headline, whatWeDoTitle, whatWeDoLists, gridItems, heroImage } = data.content;

	const whatWeDoCursors = ['communication', 'computer', 'graphics'];

	return (
		<div>
			<SEO title="Sultan & Sultan gör det enklare med reklam" keywords={[]} />
			<HomeHero heroImage={heroImage} headline={headline} introText={introText} />
			<Container my={[0, 6]} pt={[5, 4, 7]}>
				<Flex mb={4}>
					<Box>
						<Animate animateOnInView={true}>
							<H2 color="client.primary">{whatWeDoTitle}</H2>
						</Animate>
					</Box>
				</Flex>
				<Flex grid gridGap={[theme.space[3]]} gridTemplateColumns={['1fr', 'repeat(3, 1fr)']}>
					{whatWeDoLists.map((item, key) => (
						<Animate animateOnInView={true} key={item.id} delay={key * 200 + 300}>
							<Box
								cursor={whatWeDoCursors[key]}
								as="a"
								href={`/vad-vi-gor#${item.slug}`}
								css={css({
									'&:hover': {
										transition: '.2s ease',
										color: 'client.accentDark'
									}
								})}
							>
								<Ul>
									<Li fontSize={['p', 'pLarge']} bold>
										{item.listTitle}
									</Li>
									{item.listItems.map((text, key) => (
										<Li key={key}>{text}</Li>
									))}
								</Ul>
							</Box>
						</Animate>
					))}
				</Flex>
			</Container>
			<Container large py={[0, 0, 0]}>
				<Flex grid {...gridSettings}>
					{gridItems.map((item, key) => (
						<ProjectGridItem
							key={key}
							item={item}
							type={item}
							gridArea={['unset', `i${key + 3}`]}
							aspectRatio={gridSettings.aspectRatios[`i${key + 3}`] || 1}
						/>
					))}
				</Flex>
			</Container>
			<Container as="a" href="/case" cursor="glasses">
				<Flex alignItems="center" justifyContent="center">
					<Box textAlign="center">
						<H2 color="client.primary">Kolla in fler coola project</H2>
					</Box>
				</Flex>
			</Container>
		</div>
	);
};

export const query = graphql`
	query {
		content: contentfulPageIndex(contentful_id: { eq: "1HeEGf3ROp0F18gFZpGJ0a" }) {
			headline
			heroImage {
				file {
					contentType
					url
				}
				fluid(maxWidth: 2000) {
					...GatsbyContentfulFluid
				}
			}
			introText {
				value: introText
			}
			whatWeDoTitle
			whatWeDoLists {
				id
				slug
				listTitle
				listItems
			}
			gridItems {
				type: __typename
				... on ContentfulCase {
					slug
					headline
					darkText
					featuredImage {
						file {
							contentType
							url
						}
						fluid(quality: 100, maxWidth: 1600) {
							...GatsbyContentfulFluid
						}
					}
				}
				... on ContentfulPost {
					headline
					slug
					featuredImage {
						file {
							contentType
							url
						}
						fluid(quality: 100, maxWidth: 1600) {
							...GatsbyContentfulFluid
						}
					}
				}
			}
		}
	}
`;

export default IndexPage;
